import React from "react";
import {Avatar, Breadcrumb, Card, Col, Form, Input, List, Modal, Row, Typography} from "antd";
import {Link} from "react-router-dom";

import BaseComponent from "../../redare/components/BaseComponent";
import ApplicationPresenter from "../../.gen/presenter/ApplicationPresenter";
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import Button from "../../redare/components/common/Button";
import UserPresenter from "../../.gen/presenter/UserPresenter";

const {Text} = Typography;

export default class UnifiedLoginPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.applicationPresenter = new ApplicationPresenter(this);
        this.userPresenter = new UserPresenter(this);
        this.state = {
            modal1Visible: false,
            id: "",
            applicationList: []
        };
    }

    componentDidMount() {
        this._loadUserApplicationList();
    }

    _loadUserApplicationList() {
        this.applicationPresenter.findApplicationOfUserList(
            {classify: "application", isShowPC: 1},
            {},
            (result) => {
                this.setState({applicationList: result.data});
            });
    }

    _onSubmit(modal1Visible) {
        this.formRef.validateFields().then(values => {
            let item = this.state.item;
            let id = item.id;
            let saveData = {};
            saveData = {id, ...values};
            this.userApplicationPresenter.modifyUserAndPassword(saveData, {}, (result) => {
                if (result.code === 0) {
                    this.toastSuccess("账号密码设置成功!");
                    this.setState({modal1Visible});
                    setTimeout(() => {
                        this._JumpUrl(item, false)
                    }, 1000);
                }
            });
        });
    }

    handleCancel(modal1Visible) {
        let item = this.state.item;
        this.setState({modal1Visible});
        this._JumpUrl(item, true);
    }

    _closeForm(modal1Visible) {
        this.setState({modal1Visible});
    }


    //单点登录跳转
    _doLoginRedirect(item) {
        if (item.status === 1) {
            //验证账号密码
            if (item.verifyAccountAndPwd === 1) {
                this.userApplicationPresenter.findByUserAndAppId({
                    applicationId: item.applicationId,
                    pcOrMobile: 1
                }, {}, (result) => {
                    let application = result.data;
                    if (application) {
                        if (application.accountId === undefined || application.accountId === '') {
                            this.setState({modal1Visible: true, item});
                        } else {
                            this._JumpUrl(item, false);
                        }
                    }
                })
            } else {
                this._JumpUrl(item, false);
            }
        } else {
            this.toastFail("建设中...");
        }
    }

    _JumpUrl(item, openUrl) {
        let ssoToken = window._workbench._ssoToken;
        let token = "";
        if (ssoToken) {
            token = ssoToken.token;
        }
       if (item.appAccessUrl && !openUrl) {
            if (item.verifyAccountAndPwd === 0) {
                window.open(item.appAccessUrl, "_blank");
            } else {
                window.open(item.appAccessUrl + "?token=" + token, "_blank");
            }
        } else if (openUrl) {
           window.open(item.appAccessUrl, "_blank");
        } else {
            this.toastFail("建设中...");
        }
    }


    render() {
        let {applicationList} = this.state;
        return (
            <div className="UnifiedLogin-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>统一登录</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all bg-white">
                    <div className="margin024">
                        <Card title="我的应用" bordered={false}>
                            <Row>
                                <Col span={24} className="margin-top24">
                                    <List
                                        className="icon-item"
                                        dataSource={applicationList}
                                        renderItem={(post, index) => {
                                            return (
                                                <li key={post.id} className="list-item">
                                                    <a onClick={() => this._doLoginRedirect(post)} target="_blank">
                                                        <div className="icon-first">
                                                            <Avatar shape="square" size={50} src={post.icon}
                                                                    className="icon-img"/>
                                                        </div>
                                                        <p>{post.name}</p>
                                                    </a>
                                                </li>
                                            )
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </div>
                </div>
                <Modal
                    className="mod-box"
                    title="单点登录"
                    destroyOnClose={true}
                    visible={this.state.modal1Visible}
                    onCancel={() => this._closeForm(false)}
                    centered={true}
                    footer={[
                        <Button key="back" onClick={() => this.handleCancel(false)}>直接打开</Button>,
                        <Button key="submit" type="primary" onClick={() => this._onSubmit(false)}>单点登录</Button>
                    ]}
                >
                    <div className="box-con">
                        <div className="alert-box">
                            <Text>请输入您此平台的登录用户名及密码，下次将自动登录!</Text>
                        </div>
                        <Form className="padding24" ref={(o) => this.formRef = o}>
                            <Form.Item name="applicationUserId" rules={[{required: true, message: '账号不能为空'}]}>
                                <Input
                                    prefix={<UserOutlined/>}
                                    placeholder="请输入账号"

                                />
                            </Form.Item>
                            <Form.Item name="applicationUserPwd" rules={[{required: true, message: '密码不能为空'}]}>
                                <Input
                                    prefix={<LockOutlined/>}
                                    type="password"
                                    placeholder="请输入密码"
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            </div>
        )
    }
}
